import * as React from "react";

import type {Notification as Model} from "@client/features/notifications";

import {Icon} from "@client/components/Icon";
import {Prose} from "@client/components/Prose";
import {TouchHandler} from "@client/components/TouchHandler";
import {classNames} from "@reactivated";

const styles = {
    notification:
        "notification-base space-x-2.5 p-2.5 border border-solid rounded-lg flex items-center leading-[1.2]",
    message: "flex-1",
} as const;

interface Props {
    notification: Model;
    onDismiss?: () => void;
}

export const Notification = ({onDismiss, notification}: Props) => (
    <TouchHandler
        disableBackground
        blend
        onClick={onDismiss}
        // Used by our modal scenes to prevent onBlur from closing the modal.
        // See: https://github.com/tailwindlabs/headlessui/discussions/2301
        className={classNames(
            "joy-notification",
            styles.notification,
            notification.level_tag,
        )}
    >
        <div className={styles.message}>
            <Prose text={notification.message} />
        </div>
        {onDismiss && <Icon icon="0822-cross2" />}
    </TouchHandler>
);
